import { CSSProperties, ReactNode } from 'react';

import { pickBy } from 'ramda';
import type { ContainerProps, GroupBase } from 'react-select-5';

type Props<Option, IsMulti extends boolean, Group extends GroupBase<Option>> = ContainerProps<
  Option,
  IsMulti,
  Group
> & {
  label?: ReactNode;
};

export function Container<Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: Props<Option, IsMulti, Group>,
) {
  const { innerProps, selectProps, getClassNames, getStyles, label, children } = props;

  const ariaAttributes = pickBy((_, key) => key.startsWith('aria-'), selectProps) as Record<string, string>;
  const dataAttributes = pickBy((_, key) => key.startsWith('data-'), selectProps) as Record<string, string>;

  return (
    <div
      {...innerProps}
      {...ariaAttributes}
      {...dataAttributes}
      className={getClassNames('container', props)}
      style={getStyles('container', props) as CSSProperties}
    >
      {label}
      {children}
    </div>
  );
}
